import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import shallow from 'zustand/shallow'
import PerButton from '../Button'
import PerFlexRow from '../FlexRow'
import PerSpacer from '../Spacer'
import PerText from '../Text'
import PerIcon from '../Icon'
import { PerTag } from '../Tag'
import { CareerPathEvaluationState } from '../../../types'
import { useForecastModalStore, ForecastModalFilterValues } from '.'
import './index.less'

export const ForecastModalEmployeeFiltersToolbar: FC<unknown> = () => {
  const { t } = useTranslation()

  const [filterValues, deleteFilter, setFilterValues] = useForecastModalStore(
    (state) => [state.filterValues, state.deleteFilter, state.setFilterValues],
    shallow,
  )

  const onTagClose = (e: MouseEvent, filterName: keyof ForecastModalFilterValues) => {
    e.preventDefault()
    deleteFilter(filterName)
  }

  const hasValidFilters = (filerValues: ForecastModalFilterValues) => {
    return Object.keys(filterValues).some((filter) => !!filerValues[filter])
  }

  const renderPathColor = (value: CareerPathEvaluationState) => {
    if (value === CareerPathEvaluationState.Inline) {
      return 'success'
    } else {
      return 'error'
    }
  }

  const transformFilterValuesForTags = (filterName: keyof ForecastModalFilterValues) => {
    if (filterName === 'tags' && !!filterValues.tags) {
      const enumValue = filterValues.tags.replace(/_/g, ' ').toLowerCase()
      return `${t(`pyramidsView.forecastModal.filters.${filterName}`)}: ${enumValue.charAt(0).toUpperCase() + enumValue.slice(1)}`
    } else if (filterName === 'careerPath' && !!filterValues.careerPath) {
      return (
        <div className={`forecast-modal-filter-path-icon-color ${renderPathColor(filterValues.careerPath)}`}>
          {t(`pyramidsView.forecastModal.filters.${filterName}`)}:
          <PerSpacer ml="xxxs" display="inline-block" />
          <PerIcon name="circle_fill" size={10} />
        </div>
      )
    } else {
      return `${t(`pyramidsView.forecastModal.filters.${filterName}`)}: ${filterValues[filterName]}`
    }
  }

  const renderedTags = Object.keys(filterValues).map((filter, index: number) => {
    return (
      !!filterValues[filter] && (
        <React.Fragment key={`filterTag${index}`}>
          <PerSpacer ml={!!index ? 'xxxxs' : 'xxs'} />
          <PerTag
            closable
            onClose={(e: MouseEvent) => onTagClose(e, filter as keyof ForecastModalFilterValues)}
            style={{ lineHeight: 'normal' }}
          >
            <PerText display="inline-block" mr="xxxs">
              {transformFilterValuesForTags(filter as keyof ForecastModalFilterValues)}
            </PerText>
          </PerTag>
        </React.Fragment>
      )
    )
  })

  return !!hasValidFilters(filterValues) ? (
    <PerFlexRow align="middle" ml="m">
      <PerText color="secondary">{t('pyramidsView.forecastModal.filters.filtersApplied')}:</PerText>
      {renderedTags}
      <PerButton
        text={t('pyramidsView.forecastModal.filters.clearFilters')}
        color="transparent"
        before={'close_stroke'}
        type="button"
        onClick={() => setFilterValues({})}
      />
    </PerFlexRow>
  ) : null
}
